export const API_NAME = 'report-poc';
export const API_BASE_URL = `${API_NAME}`;

export const DEFAULT_ORDER: 'ASC' | 'DESC' = 'ASC';
export const DEFAULT_ROWS = 10;
